import { ItemSheetAuditLogAction } from "@/consts/Estimate";
import {
  CombinedRow,
  ItemSheetExtraData,
  ItemSheetObject,
} from "@/types/itemsheet";

export const actionTextMap: Record<ItemSheetAuditLogAction, string> = {
  [ItemSheetAuditLogAction.CREATE]: "생성",
  [ItemSheetAuditLogAction.UPDATE]: "수정",
  [ItemSheetAuditLogAction.DELETE]: "삭제",
  [ItemSheetAuditLogAction.DOWNLOAD]: "다운로드",
  [ItemSheetAuditLogAction.CREATE_FROM_FILE]: "파일로 생성",
  [ItemSheetAuditLogAction.FINALIZE]: "확정",
  [ItemSheetAuditLogAction.UNFINALIZE]: "확정 해제",
};

export const parseItemSheetObjectToRows = (
  object: ItemSheetObject
): CombinedRow[] => {
  const { data, extras } = object;
  const extraMap = new Map<string, ItemSheetExtraData>();
  extras.forEach((extra) => {
    extraMap.set(extra.data_uuid, extra);
  });

  return data.map((item) => {
    const matchedExtra = extraMap.get(item.uuid!);

    return {
      uuid: item.uuid,
      seq_no: item.seq_no,
      product_name: item.product_name,
      product_id: item.product_id,
      manufacturer: item.manufacturer,
      vendor: item.vendor,
      buyer: item.buyer,
      specification: item.specification,
      unit: item.unit,
      quantity: item.quantity,
      unit_cost: item.unit_cost,
      list_price:
        item.list_price != null ? parseFloat(String(item.list_price)) : null,
      total_cost: item.total_cost,
      total_list_price:
        item.total_list_price != null
          ? parseFloat(String(item.total_list_price))
          : null,
      list_num: item.list_num,

      tags: matchedExtra?.tags ?? [],
      googleSearchResult: matchedExtra?.google_search_result ?? [],
      purchaseHistory: matchedExtra?.purchase_history ?? [],

      extra: item.extra ?? {},
      extras: matchedExtra,
    };
  });
};
